export default function blockWooCategoriesIco() {

    if (document.querySelectorAll('.menu-categories-ico:not(.menu-categories-ico--disabled)').length === 0) {return;}

    import('swiper/bundle').then(({ default: Swiper }) => {
        document.querySelectorAll('.menu-categories-ico:not(.menu-categories-ico--disabled)').forEach(function(slider) {
            const swiper = new Swiper( slider, {
                speed: 1200,
                loop: true,
                spaceBetween: 24,
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: true,
                },
                breakpoints: {
                    0: {
                        slidesPerView: 3,
                    },
                    768: {
                        slidesPerView: 5,
                        loopAdditionalSlides: 0,
                    },
                    1200: {
                        slidesPerView: 7,
                    },
                    1400: {
                        slidesPerView: 8,
                    },
                    1550: {
                        slidesPerView: 9,
                    },
                    1746: {
                        slidesPerView: 10,
                    }
                },
            } );
        });
    });
}
